import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import back_top from "@assets/img/ai/back_top.png"
import chuangzuo from "@assets/img/ai/chuangzuo.png"
import liaotian from "@assets/img/ai/liaotian.png"
import selected from "@assets/img/ai/selected.png"
import wenxinyiyan from "@assets/img/ai/wenxinyiyan.png"
import tongyiqianwen from "@assets/img/ai/tongyiqianwen.png"
import kimi from "@assets/img/ai/kimi.png"
import create_icon from "@assets/img/ai/create_icon.png"
import history_icon from "@assets/img/ai/history_icon.png"
import profilePicture from "@assets/img/ai/profilePicture.png"
import windowsImg from "@assets/img/ai/windowsImg.png"
import stopImg from "@assets/img/ai/stop.png"
import slide from "@assets/img/ai/slide.png"
import tip_img from "@assets/img/ai/tip_img.gif"
import tip_img_line from "@assets/img/ai/tip_img_line.png"
import { InputItem, Button } from 'antd-mobile'
import { createForm } from 'rc-form';
import { translatorAiMessage, deepClone } from '@src/utils';
// import VConsole from 'vconsole';
// let vConsole = new VConsole() //log调试
class AiZone extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
            success: false,
            remainingCycle: '',
            resDetailRecord: [],
            typeData: [],
            chatMsgStreamData: [],
            chatMsgList2: [],
            chatMsgList3: [],
            chatMsgList4: [],
            apiType: '4',
            canUseSSE: false,
            showGZH: false,
            touchStartX: 0,
            touchStartY: 0,
            receivIng2: false,
            receivIng3: false,
            receivIng4: false,
            showTip: false,
            allModel: false,
        }
    }

    stopSubmit = () => {
        const _this = this;
        _this.setState({ receivIng2: false, receivIng3: false, receivIng4: false, })
    }

    doSubmit = async () => {
        if (sessionStorage.getItem('hasShowTip') == 'no') {
            this.setState({
                showTip: true
            })
            sessionStorage.setItem("hasShowTip", 'yes');
        }
        const time = new Date().getTime();
        const _this = this;
        this.props.form.validateFields(async (error, value) => {
            const question = value.question;
            if (this.state.allModel) {
                if (!error) {
                    _this.setState({ receivIng2: true }, () => {
                        try {
                            let chatMsgListNew = deepClone(this.state.chatMsgList2)
                            let arr = chatMsgListNew;
                            arr.push({ 'question': question, 'answer': '', isDone: false });
                            this.setState({ chatMsgList2: arr }, async () => {
                                fetch('/ai/chatMsgStream', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({ apiType: '2', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                }).then(response => {
                                    const reader = response.body.getReader();
                                    const decoder = new TextDecoder('utf-8');
                                    let buffer = '';

                                    function processStreamResult(result2) {
                                        const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                        buffer += chunk;
                                        //逐条解析后端返回数据
                                        const lines = buffer.split('\n');
                                        buffer = lines.pop();

                                        lines.forEach(line => {
                                            if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                // if (line == 'data:data:[DONE]') {
                                                if (line.includes('[DONE]') || line.includes('error')) {
                                                    //执行完成的页面逻辑
                                                    let chatMsgListNew = deepClone(_this.state.chatMsgList2)
                                                    let arr = chatMsgListNew
                                                    arr.map(item => {
                                                        if (!item.isDone) {
                                                            item.isDone = true;
                                                        }
                                                    })
                                                    _this.setState({ chatMsgList2: arr, receivIng2: false })

                                                } else {
                                                    // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                    const translatorData = translatorAiMessage(line)
                                                    _this.updateChatMsgList('2', question, translatorData.contents, translatorData.isDone)
                                                    _this.scrollToBottom();
                                                }

                                            }
                                        });

                                        if (!result2.done && _this.state.receivIng2) {
                                            return reader.read().then(processStreamResult);
                                        }
                                    }

                                    return reader.read().then(processStreamResult);

                                })
                                    .catch(error => {
                                        //console.error('Error:', error);
                                    });
                            })

                        } catch (error) {
                        }
                    })
                    _this.setState({ receivIng3: true }, () => {
                        try {
                            let chatMsgListNew = deepClone(this.state.chatMsgList3)
                            let arr = chatMsgListNew;
                            arr.push({ 'question': question, 'answer': '', isDone: false });
                            this.setState({ chatMsgList3: arr }, async () => {
                                fetch('/ai/chatMsgStream', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({ apiType: '3', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                }).then(response => {
                                    const reader = response.body.getReader();
                                    const decoder = new TextDecoder('utf-8');
                                    let buffer = '';

                                    function processStreamResult(result2) {
                                        const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                        buffer += chunk;
                                        //逐条解析后端返回数据
                                        const lines = buffer.split('\n');
                                        buffer = lines.pop();

                                        lines.forEach(line => {
                                            if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                // if (line == 'data:data:[DONE]') {
                                                if (line.includes('[DONE]') || line.includes('error')) {
                                                    //执行完成的页面逻辑
                                                    let chatMsgListNew = deepClone(_this.state.chatMsgList3)
                                                    let arr = chatMsgListNew
                                                    arr.map(item => {
                                                        if (!item.isDone) {
                                                            item.isDone = true;
                                                        }
                                                    })
                                                    _this.setState({ chatMsgList3: arr, receivIng3: false })

                                                } else {
                                                    // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                    const translatorData = translatorAiMessage(line)
                                                    _this.updateChatMsgList('3', question, translatorData.contents, translatorData.isDone)
                                                    _this.scrollToBottom();
                                                }

                                            }
                                        });

                                        if (!result2.done && _this.state.receivIng3) {
                                            return reader.read().then(processStreamResult);
                                        }
                                    }

                                    return reader.read().then(processStreamResult);

                                })
                                    .catch(error => {
                                        //console.error('Error:', error);
                                    });
                            })

                        } catch (error) {
                        }
                    })
                    _this.setState({ receivIng4: true }, () => {
                        try {
                            let chatMsgListNew = deepClone(this.state.chatMsgList4)
                            let arr = chatMsgListNew;
                            arr.push({ 'question': question, 'answer': '', isDone: false });
                            this.setState({ chatMsgList4: arr }, async () => {
                                fetch('/ai/chatMsgStream', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({ apiType: '4', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                }).then(response => {
                                    const reader = response.body.getReader();
                                    const decoder = new TextDecoder('utf-8');
                                    let buffer = '';

                                    function processStreamResult(result2) {
                                        const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                        buffer += chunk;
                                        //逐条解析后端返回数据
                                        const lines = buffer.split('\n');
                                        buffer = lines.pop();

                                        lines.forEach(line => {
                                            if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                // if (line == 'data:data:[DONE]') {
                                                if (line.includes('[DONE]') || line.includes('error')) {
                                                    //执行完成的页面逻辑
                                                    let chatMsgListNew = deepClone(_this.state.chatMsgList4)
                                                    let arr = chatMsgListNew
                                                    arr.map(item => {
                                                        if (!item.isDone) {
                                                            item.isDone = true;
                                                        }
                                                    })
                                                    _this.setState({ chatMsgList4: arr, receivIng4: false })

                                                } else {
                                                    // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                    const translatorData = translatorAiMessage(line)
                                                    _this.updateChatMsgList('4', question, translatorData.contents, translatorData.isDone)
                                                    _this.scrollToBottom();
                                                }

                                            }
                                        });

                                        if (!result2.done && _this.state.receivIng4) {
                                            return reader.read().then(processStreamResult);
                                        }
                                    }

                                    return reader.read().then(processStreamResult);

                                })
                                    .catch(error => {
                                        //console.error('Error:', error);
                                    });
                            })

                        } catch (error) {
                        }
                    })
                }
            } else {
                if (!error) {
                    if (this.state.apiType == '2') {
                        _this.setState({ receivIng2: true }, () => {
                            try {
                                let chatMsgListNew = deepClone(this.state.chatMsgList2)
                                let arr = chatMsgListNew;
                                arr.push({ 'question': question, 'answer': '', isDone: false });
                                this.setState({ chatMsgList2: arr }, async () => {
                                    fetch('/ai/chatMsgStream', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({ apiType: '2', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                    }).then(response => {
                                        const reader = response.body.getReader();
                                        const decoder = new TextDecoder('utf-8');
                                        let buffer = '';

                                        function processStreamResult(result2) {
                                            const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                            buffer += chunk;
                                            //逐条解析后端返回数据
                                            const lines = buffer.split('\n');
                                            buffer = lines.pop();

                                            lines.forEach(line => {
                                                if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                    // if (line == 'data:data:[DONE]') {
                                                    if (line.includes('[DONE]') || line.includes('error')) {
                                                        //执行完成的页面逻辑
                                                        let chatMsgListNew = deepClone(_this.state.chatMsgList2)
                                                        let arr = chatMsgListNew
                                                        arr.map(item => {
                                                            if (!item.isDone) {
                                                                item.isDone = true;
                                                            }
                                                        })
                                                        _this.setState({ chatMsgList2: arr, receivIng2: false })

                                                    } else {
                                                        // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                        const translatorData = translatorAiMessage(line)
                                                        _this.updateChatMsgList('2', question, translatorData.contents, translatorData.isDone)
                                                        _this.scrollToBottom();
                                                    }

                                                }
                                            });

                                            if (!result2.done && _this.state.receivIng2) {
                                                return reader.read().then(processStreamResult);
                                            }
                                        }

                                        return reader.read().then(processStreamResult);

                                    })
                                        .catch(error => {
                                            //console.error('Error:', error);
                                        });
                                })

                            } catch (error) {
                            }
                        })
                    } else if (this.state.apiType == '3') {
                        _this.setState({ receivIng3: true }, () => {
                            try {
                                let chatMsgListNew = deepClone(this.state.chatMsgList3)
                                let arr = chatMsgListNew;
                                arr.push({ 'question': question, 'answer': '', isDone: false });
                                this.setState({ chatMsgList3: arr }, async () => {
                                    fetch('/ai/chatMsgStream', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({ apiType: '3', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                    }).then(response => {
                                        const reader = response.body.getReader();
                                        const decoder = new TextDecoder('utf-8');
                                        let buffer = '';

                                        function processStreamResult(result2) {
                                            const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                            buffer += chunk;
                                            //逐条解析后端返回数据
                                            const lines = buffer.split('\n');
                                            buffer = lines.pop();

                                            lines.forEach(line => {
                                                if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                    // if (line == 'data:data:[DONE]') {
                                                    if (line.includes('[DONE]') || line.includes('error')) {
                                                        //执行完成的页面逻辑
                                                        let chatMsgListNew = deepClone(_this.state.chatMsgList3)
                                                        let arr = chatMsgListNew
                                                        arr.map(item => {
                                                            if (!item.isDone) {
                                                                item.isDone = true;
                                                            }
                                                        })
                                                        _this.setState({ chatMsgList3: arr, receivIng3: false })

                                                    } else {
                                                        // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                        const translatorData = translatorAiMessage(line)
                                                        _this.updateChatMsgList('3', question, translatorData.contents, translatorData.isDone)
                                                        _this.scrollToBottom();
                                                    }

                                                }
                                            });

                                            if (!result2.done && _this.state.receivIng3) {
                                                return reader.read().then(processStreamResult);
                                            }
                                        }

                                        return reader.read().then(processStreamResult);

                                    })
                                        .catch(error => {
                                            //console.error('Error:', error);
                                        });
                                })

                            } catch (error) {
                            }
                        })
                    } else if (this.state.apiType == '4') {
                        _this.setState({ receivIng4: true }, () => {
                            try {
                                let chatMsgListNew = deepClone(this.state.chatMsgList4)
                                let arr = chatMsgListNew;
                                arr.push({ 'question': question, 'answer': '', isDone: false });
                                this.setState({ chatMsgList4: arr }, async () => {
                                    fetch('/ai/chatMsgStream', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({ apiType: '4', qes: question, openId: sessionStorage.getItem('openid'), unionId: sessionStorage.getItem('unionid') }),
                                    }).then(response => {
                                        const reader = response.body.getReader();
                                        const decoder = new TextDecoder('utf-8');
                                        let buffer = '';

                                        function processStreamResult(result2) {
                                            const chunk = decoder.decode(result2.value, { stream: !result2.done });
                                            buffer += chunk;
                                            //逐条解析后端返回数据
                                            const lines = buffer.split('\n');
                                            buffer = lines.pop();

                                            lines.forEach(line => {
                                                if (line.replace(/^\s+|\s+$/gm, '').length > 0) {
                                                    // if (line == 'data:data:[DONE]') {
                                                    if (line.includes('[DONE]') || line.includes('error')) {
                                                        //执行完成的页面逻辑
                                                        let chatMsgListNew = deepClone(_this.state.chatMsgList4)
                                                        let arr = chatMsgListNew
                                                        arr.map(item => {
                                                            if (!item.isDone) {
                                                                item.isDone = true;
                                                            }
                                                        })
                                                        _this.setState({ chatMsgList4: arr, receivIng4: false })

                                                    } else {
                                                        // const translatorData = translatorAiMessage(JSON.parse(JSON.stringify(line)))
                                                        const translatorData = translatorAiMessage(line)
                                                        _this.updateChatMsgList('4', question, translatorData.contents, translatorData.isDone)
                                                        _this.scrollToBottom();
                                                    }

                                                }
                                            });

                                            if (!result2.done && _this.state.receivIng4) {
                                                return reader.read().then(processStreamResult);
                                            }
                                        }

                                        return reader.read().then(processStreamResult);

                                    })
                                        .catch(error => {
                                            //console.error('Error:', error);
                                        });
                                })

                            } catch (error) {
                            }
                        })
                    }
                }
            }
            this.props.form.setFieldsValue({ question: '' })
        })
    };

    updateChatMsgList = (type, ques, contents, isDone) => { //1:百川，2:月之暗面,3:阿里灵积,4:百度文心
        if (type == '2') {
            let chatMsgListNew = deepClone(this.state.chatMsgList2)
            let arr = chatMsgListNew
            arr.map(item => {
                if (item.question == ques && !item.isDone) {
                    item.answer += contents;
                    item.isDone = isDone;
                }
            })
            this.setState({ chatMsgList2: arr })
        } else if (type == '3') {
            let chatMsgListNew = deepClone(this.state.chatMsgList3)
            let arr = chatMsgListNew
            arr.map(item => {
                if (item.question == ques && !item.isDone) {
                    item.answer += contents;
                    item.isDone = isDone;
                }
            })
            this.setState({ chatMsgList3: arr })
        } else if (type == '4') {
            let chatMsgListNew = deepClone(this.state.chatMsgList4)
            let arr = chatMsgListNew
            arr.map(item => {
                if (item.question == ques && !item.isDone) {
                    item.answer += contents;
                    item.isDone = isDone;
                }
            })
            this.setState({ chatMsgList4: arr })
        }

    }

    getUrlParam(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = window.location.href.split('#')[0]
        let search = url.split('?')[1]
        if (search) {
            var r = search.substr(0).match(reg)
            if (r !== null)
                return unescape(r[2])
            return null
        } else
            return null
    }


    getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    async componentDidMount() {
        sessionStorage.setItem("hasShowTip", 'no');
        document.title = 'AI专区'


        // sessionStorage.setItem("openid", 'oucMy6uj-Yd7Ilt50gmivutT-vwY');
        // sessionStorage.setItem("unionid", 'op8inw3QVZDf92jQRWlRSNRIeQWQ');
        // sessionStorage.setItem("nickname", 'Damon');
        // sessionStorage.setItem("headimgurl", 'https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eq1QcicWB6J93zicIAlNLE1yEtzW5RwF38uVHvCfljY1KdEF03ND8ngGKstx16Lk3et3q1rvySKkqOQ/132');

        const code = this.getUrlParam('code')  // 截取路径中的code
        if ((code == null || code === '') && !sessionStorage.getItem('openid')) {
            const local = window.location.href
            console.log("local", local)
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6f5057302da09451&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect';
        } else if (!sessionStorage.getItem('openid')) {
            const res = await this.api.getOpenId({ code }) //把code传给后台获取用户信息
            console.log('把code传给后台获取用户信息', res)
            if (!res.openid) {
                // 提示没有关注公众号 没有关注公众号跳转到关注公众号页面
                console.log('您还未关注公众号喔');
                this.setState({ showGZH: true })
                return;
            } else {
                // 本地存储这个openid，并刷新页面
                // console.log("拿到微信信息", res)
                sessionStorage.setItem("openid", res.openid);
                sessionStorage.setItem("unionid", res.unionid);
                sessionStorage.setItem("nickname", res.nickname);
                sessionStorage.setItem("headimgurl", res.headimgurl);
                // this.api.getAiUseLog({ openId: res.openid })
                location.reload();
            }
        } else if (sessionStorage.getItem('openid')) {
            this.setState({ showGZH: false })
            this.$toast.loading('加载中，请稍等', 15)
            const typeData = [] = await this.api.getAiType({})
            this.$toast.hide()
            this.setState({
                typeData,
                chatMsgList2: [
                    { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true }],
                chatMsgList3: [
                    { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true }],
                chatMsgList4: [
                    { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true }]
            })
            this.api.getAiUseLog({ openId: sessionStorage.getItem('openid'), apiType: this.state.apiType })
        }

        this.setState({ showGZH: false })
        this.$toast.loading('加载中，请稍等', 15)
        const typeData = [] = await this.api.getAiType({})
        this.$toast.hide()
        this.setState({
            typeData,
            chatMsgList2: [
                { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true }],
            chatMsgList3: [
                { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true }],
            chatMsgList4: [
                { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true }]

        })

        const queryString = window.location.href;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get('id'); // 替换paramName为你要获取的参数名
        // console.log(id); // 输出参数值 
        const apiTypeUrl = urlParams.get('apiType'); // 替换paramName为你要获取的参数名  
        // console.log(apiTypeUrl); // 输出参数值
        if (apiTypeUrl && id) {
            const resHistory = await this.api.getMsgLog({ id })
            // console.log("resHistory", resHistory)
            if (resHistory.question && resHistory.content) {
                if (apiTypeUrl == '2') {
                    this.setState({
                        apiType: apiTypeUrl,
                        chatMsgList2: [
                            { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true },
                            { 'question': resHistory.question, 'answer': resHistory.content, isDone: true }
                        ],
                        chatMsgList3: [
                            { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true }
                        ],
                        chatMsgList4: [
                            { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true }]
                    })
                } else if (apiTypeUrl == '3') {
                    this.setState({
                        apiType: apiTypeUrl,
                        chatMsgList2: [
                            { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true }
                        ],
                        chatMsgList3: [
                            { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true },
                            { 'question': resHistory.question, 'answer': resHistory.content, isDone: true }
                        ],
                        chatMsgList4: [
                            { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true }]
                    })
                } else if (apiTypeUrl == '4') {
                    this.setState({
                        apiType: apiTypeUrl,
                        chatMsgList2: [
                            { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true }
                        ],
                        chatMsgList3: [
                            { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true }
                        ],
                        chatMsgList4: [
                            { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true },
                            { 'question': resHistory.question, 'answer': resHistory.content, isDone: true }]
                    })
                }
            }
        }

        // this.api.getChatMsgLog({ openId: sessionStorage.getItem('openid'), apiTypes: ['2', '3', '4'] })
    }




    imgs = { 4: wenxinyiyan, 3: tongyiqianwen, 2: kimi }


    handleTouchStart = (e) => {
        const touch = e.touches[0] || e.changedTouches[0];
        this.setState({
            touchStartX: touch.clientX,
            touchStartY: touch.clientY
        })
    };

    handleTouchEnd = (e) => {
        const touch = e.touches[0] || e.changedTouches[0];
        if (touch.clientX - this.state.touchStartX < -40 && Math.abs(touch.clientY - this.state.touchStartY) < 150) {
            this.setState({
                apiType: this.state.apiType - 1 <= 2 ? 2 : this.state.apiType - 1
            })
            this.api.getAiUseLog({ openId: sessionStorage.getItem('openid'), apiType: this.state.apiType - 1 <= 2 ? 2 : this.state.apiType - 1 })
        } else if (touch.clientX - this.state.touchStartX > 40 && Math.abs(touch.clientY - this.state.touchStartY) < 150) {
            this.setState({
                apiType: this.state.apiType + 1 >= 4 ? 4 : this.state.apiType + 1
            })
            this.api.getAiUseLog({ openId: sessionStorage.getItem('openid'), apiType: this.state.apiType - 1 <= 2 ? 2 : this.state.apiType - 1 })
        }
        // 重置状态
        this.setState({
            touchStartX: 0,
        })
    };

    messagesEndRef = React.createRef();
    scrollToBottom = () => {
        const div = this.messagesEndRef.current;
        div.scrollIntoView({ behavior: "smooth", block: "end" });
    };

    doCreate = () => {
        this.setState({
            receivIng2: false,
            receivIng3: false,
            receivIng4: false,
            chatMsgList2: [
                { 'question': '', 'answer': 'Hi，我是Kimi，别焦虑，Kimi每一次都会集中全力帮你整理资料。', isDone: true }],
            chatMsgList3: [
                { 'question': '', 'answer': 'Hi，我是通义千问，我能理解人类语言、生成内容，是你生活和工作的智能助手。', isDone: true }],
            chatMsgList4: [
                { 'question': '', 'answer': 'Hi，我是文心一言，作为你的智能伙伴，我既能写文案、想点子，又能陪你聊天、答疑解惑。', isDone: true }]
        })
    }

    getHistory = () => {
        this.goToPath('/AiZoneHistory')
    }

    closeTip = () => {
        this.setState({ showTip: false })
    }

    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <>
                {!this.state.showGZH && (
                    <div className={styles.AiZoneWrapper}
                        onTouchStart={this.handleTouchStart}
                        onTouchEnd={this.handleTouchEnd}
                    >
                        {/*顶部类目*/}
                        <div className={styles.content1} style={{ backgroundImage: `url(${back_top})` }}>
                            <div className={styles.tab1}>
                                <div className={styles.tab1left}>
                                    <div className={styles.text1}>小懂聊天</div>
                                    <div className={styles.text2}>测试版</div>
                                </div>
                                <div className={styles.tab1right}>
                                    <img className={styles.tab1rightImg} src={liaotian} alt="" />
                                </div>
                            </div>
                            <div className={styles.tab2}>
                                <div className={styles.tab2left}>
                                    <div className={styles.text1}>小懂创作</div>
                                    <div className={styles.text2}>敬请期待</div>
                                </div>
                                <div className={styles.tab2right}>
                                    <img className={styles.tab2rightImg} src={chuangzuo} alt="" />
                                </div>
                            </div>
                        </div>
                        {/*顶部接入大模型*/}
                        <div className={styles.content2}>
                            {this.state.typeData.length > 0 && (
                                this.state.typeData.map((item) => {
                                    return <div className={styles.contentTab} style={{ border: this.state.apiType == Object.keys(item)[0] ? '1px solid #FF5E19' : '' }}
                                        onClick={() => {
                                            this.setState({ apiType: Object.keys(item)[0] });
                                            this.api.getAiUseLog({ openId: sessionStorage.getItem('openid'), apiType: Object.keys(item)[0] })
                                            // this.scrollToBottom();
                                        }}
                                    >
                                        <img className={styles.contentTabImg} src={this.imgs[Object.keys(item)[0]]} alt="" />
                                        <div className={styles.contentTabText}>{Object.values(item)[0]}</div>
                                    </div>
                                })
                            )}
                            {this.state.typeData.length > 0 && (
                                <div className={this.state.allModel ? styles.allModel : styles.singleModel} onClick={() => {
                                    if (!(this.state.receivIng2 || this.state.receivIng3 || this.state.receivIng4)) {
                                        this.setState({ allModel: !this.state.allModel })
                                    }
                                }}>
                                    {this.state.allModel ? '取消对比' : '对比问答'}
                                </div>
                            )}
                        </div>
                        {/*对话区*/}
                        <div className={styles.content3}>
                            <div className={styles.allContent}>
                                {this.state.apiType == '2' && (
                                    <>  {this.state.chatMsgList2 && this.state.chatMsgList2.length > 0 && (
                                        this.state.chatMsgList2.map((item, index) => {
                                            return <>
                                                <div className={styles.myContent}>
                                                    {this.state.chatMsgList2[index].question && (
                                                        <>
                                                            <div className={styles.myText}>
                                                                <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList2[index].question }} />
                                                            </div>
                                                            <img className={styles.myIcon} src={sessionStorage.getItem('headimgurl') || profilePicture} alt="" />
                                                        </>
                                                    )}
                                                </div>
                                                <div className={styles.aiContent}>
                                                    <img className={styles.aiIcon} src={this.imgs[this.state.apiType]} alt="" />
                                                    <div className={styles.aiText}>
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList2[index].answer || '思考中...' }} />
                                                    </div>
                                                </div>
                                            </>
                                        })
                                    )}</>
                                )}
                                {this.state.apiType == '3' && (
                                    <>  {this.state.chatMsgList3 && this.state.chatMsgList3.length > 0 && (
                                        this.state.chatMsgList3.map((item, index) => {
                                            return <>
                                                <div className={styles.myContent}>
                                                    {this.state.chatMsgList3[index].question && (
                                                        <>
                                                            <div className={styles.myText}>
                                                                <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList3[index].question }} />
                                                            </div>
                                                            <img className={styles.myIcon} src={sessionStorage.getItem('headimgurl') || profilePicture} alt="" />
                                                        </>
                                                    )}
                                                </div>
                                                <div className={styles.aiContent}>
                                                    <img className={styles.aiIcon} src={this.imgs[this.state.apiType]} alt="" />
                                                    <div className={styles.aiText}>
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList3[index].answer || '思考中...' }} />
                                                    </div>
                                                </div>
                                            </>
                                        })
                                    )}</>
                                )}
                                {this.state.apiType == '4' && (
                                    <>  {this.state.chatMsgList4 && this.state.chatMsgList4.length > 0 && (
                                        this.state.chatMsgList4.map((item, index) => {
                                            return <>
                                                <div className={styles.myContent}>
                                                    {this.state.chatMsgList4[index].question && (
                                                        <>
                                                            <div className={styles.myText}>
                                                                <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList4[index].question }} />
                                                            </div>
                                                            <img className={styles.myIcon} src={sessionStorage.getItem('headimgurl') || profilePicture} alt="" />
                                                        </>
                                                    )}
                                                </div>
                                                <div className={styles.aiContent}>
                                                    <img className={styles.aiIcon} src={this.imgs[this.state.apiType]} alt="" />
                                                    <div className={styles.aiText}>
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.chatMsgList4[index].answer || '思考中...' }} />
                                                    </div>
                                                </div>
                                            </>
                                        })
                                    )}</>
                                )}
                            </div>
                            <div ref={this.messagesEndRef} />
                        </div>
                        {/*提问区*/}
                        <div className={styles.content4}>
                            <div className={styles.silde}>
                                <div className={styles.sildeContent}>
                                    <img className={styles.sildeImg} src={slide} alt="" />
                                    <div className={styles.sildeText}>
                                        左右<span style={{ color: '#FF5E19' }}>滑动页面</span>切换AI模型
                                    </div>
                                </div>
                            </div>
                            <div className={styles.silde}>
                                <div className={styles.sildeContent}>
                                    <img className={styles.sildeImg} src={slide} alt="" />
                                    <div className={styles.sildeText}>
                                        左右<span style={{ color: '#FF5E19' }}>滑动页面</span>切换AI模型
                                    </div>
                                </div>
                            </div>

                            <div className={styles.contentTop}>
                                <div className={styles.top1}>
                                    <InputItem
                                        {...getFieldProps('question',)}
                                        placeholder={'试试在这里输入你的问题'}
                                        className={styles.question}
                                    />
                                    {/* <div className={styles.question}>试试在这里输入你的问题</div> */}
                                    {(this.state.receivIng2 || this.state.receivIng3 || this.state.receivIng4) && (
                                        <div className={styles.enter}>
                                            <div className={styles.enterText} onClick={this.stopSubmit}>
                                                <div style={{ display: 'flex' }}> <img src={stopImg} className={styles.stopImg} alt="" /> <div>停止</div></div>
                                            </div>
                                        </div>
                                    )}
                                    {!(this.state.receivIng2 || this.state.receivIng3 || this.state.receivIng4) && (
                                        <div className={styles.enter}>
                                            <div className={styles.enterText} onClick={this.doSubmit}>
                                                <div>发送</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className={styles.top2}>内容由AI大模型生成，请仔细甄别</div>
                            </div>
                        </div>

                        <div className={styles.rightIcon}>
                            <div className={styles.create} onClick={this.doCreate}>
                                <img src={create_icon} className={styles.create_icon} alt="" />
                                <div className={styles.create_text}>新建</div>
                            </div>
                            <div className={styles.history} onClick={this.getHistory}>
                                <img src={history_icon} className={styles.history_icon} alt="" />
                                <div className={styles.history_text}>历史</div>
                            </div>
                        </div>
                        {this.state.showTip && (
                            <div className={styles.AiZoneTip} onClick={this.closeTip}>
                                <div className={styles.TipImg}>
                                    <img className={styles.TipImgItem} src={tip_img_line} alt="" />
                                    <img className={styles.TipImgItem} src={tip_img} alt="" />
                                </div>
                                <div className={styles.TipText}>
                                    <div>左右滑动页面</div>
                                    <div>对比其他AI模型的回复</div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {this.state.showGZH && (
                    <div className={styles.AiZoneWindow}>
                        <img className={styles.windowsImg} src={windowsImg} alt="" />
                    </div>
                )}
            </>

        )
    }
}
export default createForm()(AiZone)